// extracted by mini-css-extract-plugin
export default {"optionSelect":"SelectOptionAdd-module__optionSelect___r_tKy","newOption":"SelectOptionAdd-module__newOption___YoJBr","iconWrapper":"SelectOptionAdd-module__iconWrapper___vkXvJ"};